<template>
  <div>
    <el-form
      :model="formData"
      label-width="160px"
      class="ccui-form ccui-form-detail"
    >
      <el-form-item label="姓名：">
        {{ formData.name }}
      </el-form-item>
      <el-form-item label="性别：">
        {{ formData.sex }}
      </el-form-item>
      <el-form-item label="职务：">
        {{ formData.empName }}
      </el-form-item>
      <el-form-item label="所在单位：">
        {{ formData.orgName }}
      </el-form-item>
      <el-form-item label="所在部门：">
        <!--          {{ formData.workYears }}-->
        <div
          class="ccui-form-choseContent"
          style="line-height: 0;flex-wrap: wrap;"
        >
          <span v-for="(item, index) in formData.deptnames" :key="index">
            <span :title="item" class="abbrName" style="margin-top: 0">
              {{ item }}
              <span
                @click="deleteClass(index)"
                class="el-icon-close close"
                style="color:#999999; display: none"
              ></span>
            </span>
          </span>
          <el-button
            plain
            type="single-number"
            style="margin-left:10px;"
            @click="handleShows"
          >
            选择
          </el-button>
        </div>
      </el-form-item>
      <el-form-item label="用户名：">
        {{ formData.loginname }}
      </el-form-item>
      <el-form-item label="手机号：">
        {{ formData.mobile }}
      </el-form-item>
      <el-form-item label="4A组织编码：">
        {{ formData.extOid }}
      </el-form-item>
      <el-form-item label="单位账号(UserID)：">
        {{ formData.userId }}
      </el-form-item>
      <el-form-item label="单位账号状态：">
        {{ formData.userStatus }}
      </el-form-item>
      <el-form-item label="用户类别：">
        {{ formData.state }}
      </el-form-item>

      <el-form-item label="应用访问权限：">
        <p style="display: initial;" v-if="formData.agentState == '允许访问'">
          {{ formData.agentState }}
        </p>
        <p style="display: initial;color: rgb(235, 9, 12)" v-else>
          {{ formData.agentState }}
        </p>
        <el-button
          @click="upAgentState(formData.agentState)"
          size="mini"
          type="primary"
          style="margin-left: 10px;"
          >{{
            formData.agentState == "允许访问" ? "禁止访问" : "允许访问"
          }}</el-button
        >
      </el-form-item>
    </el-form>
    <!-- 所在部门-->
    <el-sorting-selector
      :dialogVisible.sync="dialogVisible"
      :staff="staff"
      :title="Title"
      :titleSubtotal="titleSubtotal"
      @deleteStaff="deleteStaff"
      @gitSelectedStaff="getSelectedStaff"
      ref="sorgtingDOW"
    >
      <template slot="sortingSelectorTree">
        <el-org-tree
          :autoCode="autoCode"
          :expandedKeys="expandedKeys"
          :fetchSuggestions="searchQuery"
          :isCache="true"
          :loadNode="loadNode"
          :placeholder="placeholder"
          :seachData="seachData"
          @leftOrgTree="handleLeftOrgTree"
          @select="handleSelect"
          @slectOrgSuccess="slectOrgSuccess"
          v-if="leftLevelBelowisShow"
        >
          <template slot="up" slot-scope="{ item }">
            <div :title="item.value" style="display: flex">
              <div :title="item.value" class="orgName">
                <i
                  :class="handleIconClass(item)"
                  class="orgIcon"
                  style="color: #0089EF"
                ></i>
                <span style="margin-left: 5px;">{{ item.value }}</span>
              </div>
              <p class="orgFullName">{{ item.abbrName }}</p>
            </div>
          </template>
          <template slot="upTree" slot-scope="{ node }">
            <i
              :class="handleIconClass(node.data, node.level)"
              class="orgIcon"
              style="margin-right:10px;"
            ></i>
            <span>{{ node.label }}</span>
            <i class="icon-ccui-check orgIcon" v-show="node.checked"></i>
          </template>
        </el-org-tree>
      </template>
      <template slot="sortingSelectorRight">
        <div class="el-dialog-box2 el-dialog-box" style="width: 485px">
          <span
            style="
              height: 20px;
              font-size: 14px;
              font-weight: 500;
              padding: 10px 20px;
              color: #4a4a4a;
              line-height: 20px;
              display: block;
              border-bottom: 1px solid #f1f1f1;
          "
            >{{ titleSubtotal }}</span
          >
          <span
            :key="i"
            class="custom-tree-node"
            style="
              display: block;
              position: relative;
              margin: 5px 35px;"
            v-for="(item, i) in staff"
          >
            <span
              style="position: relative; left: -10px;color: #D8D8D8;"
            ></span>
            <span
              class="el-dialog-box2-txt1"
              style="
              width: 6px;
              height: 6px;
              background: #0089ef;
              display: block;
              position: absolute;
              top: 7px;
              left: -15px;
              border-radius: 6px;
              "
              v-if="!item.data.isShow"
            ></span>
            <span :title="item.data.orderName" class="el-dialog-box2-txt">{{
              item.data.orderName
            }}</span>
            <span
              style="cursor:pointer; color: #D8D8D8; margin-right: 10px; float: right;"
              ><i @click="deleteStaff(item)" class="el-icon-close"></i
            ></span>
            <span
              :title="item.data.orderName"
              class="el-dialog-box2-txt2"
              style="
                  font-size: 13px;
                  display: block;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #999999;"
              >{{ item.data.orgFullName }}</span
            >
          </span>
        </div>
      </template>
    </el-sorting-selector>
  </div>
</template>

<script>
import {
  addUserPartyRelation,
  editAppUserState,
  getAppUser,
  getdepartment,
  getdepartmentSearch
} from "../api/item-list";

export default {
  name: "basicInfor",
  props: {},
  data() {
    return {
      formData: {},
      id: "",
      choseCheck: [],
      dialogVisible: false, // 所在部门
      selectorList: [],
      Title: "选择部门分类",
      titleSubtotal: "已选择部门(0)",
      props: {
        label: "name",
        children: "children"
      },
      autoCode: "",
      placeholder: " 定位查找",
      count: 1,
      seachData: "",
      tableListParam: {},
      param: {
        parentId: "",
        flag: 0 // 展示层级 0 公司 1部门 2 成员
      },
      leftLevelBelowisShow: true,
      leftOrgTreea: "",
      defaultProps: {
        label: "orderName",
        id: "partyId",
        children: "child",
        isLeaf: "isLeaf"
      },
      expandedKeys: [],
      defaultKeys: [],
      nodeItem: [],
      staff: [
        // { id: 18, data: { orderName: "三全鲜食17", partyId: 18 } }
      ],
      expandedKey: []
    };
  },
  mounted() {
    this.id = this.$route.params.roleId;
    this.getdepartment();
    this.getAppUser();
  },
  methods: {
    handleShows() {
      this.$refs.sorgtingDOW.sortingSelectorWidth = "848px";
      this.dialogVisible = true;
      this.staff = [];
      this.titleSubtotal = "已选择部门(0)";
    },
    deleteStaff(data) {
      this.leftOrgTreea.setChecked(data.data.partyId, false);
      this.staff = this.staff.filter(
        item => item.data.partyId !== data.data.partyId
      );
      this.titleSubtotal = `已选择部门(${this.staff.length})`;
    },
    // 选择部门确定
    getSelectedStaff(data) {
      this.choseCheck = [];
      let deptID = [];
      let openID = "";
      let state = "";
      data.forEach(item => {
        this.choseCheck.push(item.data);
        this.choseCheck.forEach(i => {
          if (i.autoCode.indexOf("-") > -1) {
            this.expandedKeys = [];
            this.defaultKeys = [];
            i.autoCode = i.autoCode.split("-");
            i.autoCode.forEach((h, index) => {
              if (h == "") {
                i.autoCode.splice(index, 1);
              }
            });
            let autoCode = i.autoCode.slice(0, i.autoCode.length - 1);
            autoCode.forEach(i => {
              this.expandedKeys.push(i);
            });
            let autoCode1 = i.autoCode.slice(
              i.autoCode.length - 1,
              i.autoCode.length
            );
            autoCode1.forEach(i => {
              this.defaultKeys.push(i);
            });
          }
        });
        this.expandedKeys = [...new Set(this.expandedKeys)];
        this.defaultKeys = [...new Set(this.defaultKeys)];
        this.choseCheck.map(item => {
          deptID.push(item.deptId);
        });
        openID = this.formData.userId.split("@")[0];
        state = this.formData.state === "正式" ? 0 : 1;
      });
      addUserPartyRelation({ deptID, openID, state }).then(res => {
        if (res.data.code === "0") {
          this.getAppUser();
        }
      });
    },
    // 选择部门点击树
    slectOrgSuccess(obj, node, tree) {
      if (obj.orgType === "1") {
        this.$set(node, "checked", true);
        this.staff.unshift(node);
        let obj = {};
        this.staff = this.staff.reduce(function(item, next) {
          obj[next.id] ? "" : (obj[next.id] = true && item.push(next));
          return item;
        }, []);
        this.titleSubtotal = `已选择部门(${this.staff.length})`;
      }
      //单选
      // if (node.level === 4 || node.level === 3) {
      //   this.$set(node, "checked", true);
      //   this.$set(this.nodeItem, "checked", false);
      //   if (node.checked === true) {
      //     this.leftOrgTreea.setCheckedKeys([obj.partyId]);
      //   }
      //   let objadd = this.leftOrgTreea.getCheckedNodes();
      //   let add = [
      //     {
      //       data: objadd[objadd.length - 1]
      //     }
      //   ];
      //   this.staff = add;
      //   this.titleSubtotal = `已选择部门(${this.staff.length})`;
      // }
      if (obj.partyId) {
        this.tableListParam.partyId = obj.partyId;
      }
      this.nodeItem = node;
      if (obj.id) {
        this.tableListParam.id = Number(obj.id);
        sessionStorage.id = JSON.stringify(this.tableListParam.id);
        if (this.$refs.selectTabs) {
          this.$refs.selectTabs.getDataList(JSON.parse(sessionStorage.id), obj);
        }
      }
      if (obj.isLeaf) {
        sessionStorage.isLeaf = this.tableListParam.isLeaf;
      }
    },
    handleSelect(item) {
      this.expandedKeys = item.autoCode.split("-");
      this.leftLevelBelowisShow = false;
      this.$nextTick(() => {
        this.autoCode = item.autoCode;
        this.param.partyId = item.partyId;
        this.leftLevelBelowisShow = true;
      });
    },
    handleLeftOrgTree(data) {
      this.leftOrgTreea = data;
    },
    // 部门树懒加载数据
    loadNode(node, resolve) {
      if (node.level === 0) {
        getdepartment({ flag: 1 }).then(res => {
          return resolve(res.data.data);
        });
      }
      if (node.level > 0) {
        getdepartment({ flag: 1, parentId: node.data.partyId }).then(res => {
          return resolve(res.data.data[0].child);
        });
      }
    },
    // 部门树搜索
    searchQuery(queryString, cb) {
      getdepartmentSearch({
        flag: 3,
        branchName: queryString
      }).then(res => {
        cb(res.data.data.rows);
      });
      // var restaurants = this.restaurants;
      // var results = queryString
      //   ? restaurants.filter(this.createFilter(queryString))
      //   : restaurants;
      // // 调用 callback 返回建议列表的数据
      // cb(results);
      // if (sessionStorage.oldSeachData === queryString) {
      //   cb(this.resultJsonParse(sessionStorage.seachResult));
      // } else {
      //   let restaurants = this.restaurants;
      //   sessionStorage.seachResult = restaurants;
      //   cb(restaurants);
      // }
    },
    // 请求部门
    getdepartment() {
      getdepartment({ flag: 1 }).then(res => {
        res.data.data.forEach(item => {
          this.selectorList.push(item);
        });
      });
    },
    // 详情用户信息
    getAppUser() {
      getAppUser({ id: this.id }).then(res => {
        this.formData = res.data.data;
      });
    },
    // 应用访问权限变更
    upAgentState(a) {
      // "id":"5","appStatus":"0" （1禁止访问、0允许访问）
      let appStatus = a == "禁止访问" ? 0 : 1;
      editAppUserState({ id: this.id, appStatus: appStatus }).then(res => {
        this.$emit("getSubmit");
        this.getAppUser();
      });
    },
    // 部门相关图标
    handleIconClass(i, w) {
      // let arr = [
      //   "icon-ccui-organization",
      //   "icon-ccui-unit",
      //   "icon-ccui-man-hollow",
      //   "icon-ccui-woman-hollow"
      // ];
      let keyClass = "";

      if (i.orgType === "0") {
        keyClass = "icon-ccui-organization is-leaf-org";
      }
      if (i.orgType === "1") {
        keyClass = "icon-ccui-unit is-leaf-org";
      }
      let obj = {};
      obj[keyClass] = true;
      return obj;
    }
  }
};
</script>

<style scoped lang="scss">
.ccui-form.ccui-form-detail .el-form-item {
  margin-bottom: 10px;
}
</style>
